import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = { class: "tab-container" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Tất cả thiết bị ", -1)
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thiết bị tiếp nhận: ", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_14 = {
  class: "vertical-align-middle ml-2 font-bold line-height-3",
  style: {"font-weight":"bold"}
}
const _hoisted_15 = {
  class: "flex justify-content-end font-bold w-full",
  style: {"font-weight":"bold"}
}
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng nhận:", -1)
const _hoisted_22 = {
  key: 0,
  class: "p-error"
}
const _hoisted_23 = { class: "list_button" }
const _hoisted_24 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_25 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Vui lòng nhập lý do:", -1)
const _hoisted_29 = {
  key: 0,
  class: "p-error"
}
const _hoisted_30 = { class: "list_button" }
const _hoisted_31 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_32 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_34 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Vui lòng nhập lý do:", -1)
const _hoisted_36 = {
  key: 0,
  class: "p-error"
}
const _hoisted_37 = { class: "list_button" }
const _hoisted_38 = { class: "flex align-items-center gap-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Thiết bị đang hoạt động ", -1)
const _hoisted_40 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Xuất tập tin:", -1)
const _hoisted_44 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Tải tập tin:", -1)
const _hoisted_46 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_47 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_48 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_50 = {
  class: "vertical-align-middle ml-2 font-bold line-height-3",
  style: {"font-weight":"bold"}
}
const _hoisted_51 = {
  class: "flex justify-content-end font-bold w-full",
  style: {"font-weight":"bold"}
}
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_53 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_54 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_56 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng nhận:", -1)
const _hoisted_58 = {
  key: 0,
  class: "p-error"
}
const _hoisted_59 = { class: "list_button" }
const _hoisted_60 = { class: "flex align-items-center gap-2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Thiết bị quá hạn hao mòn ", -1)
const _hoisted_62 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_64 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian quá hạn: ", -1)
const _hoisted_66 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", null, "Xuất tập tin:", -1)
const _hoisted_68 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", null, "Tải tập tin:", -1)
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_71 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_72 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_74 = { class: "flex align-items-center gap-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Thiết bị chờ thanh lý ", -1)
const _hoisted_76 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_78 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian chờ thanh lý: ", -1)
const _hoisted_80 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", null, "Xuất tập tin:", -1)
const _hoisted_82 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", null, "Tải tập tin:", -1)
const _hoisted_84 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_85 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_86 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_88 = { class: "flex align-items-center gap-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Thiết bị đã thanh lý ", -1)
const _hoisted_90 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_92 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thanh lý: ", -1)
const _hoisted_94 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", null, "Xuất tập tin:", -1)
const _hoisted_96 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", null, "Tải tập tin:", -1)
const _hoisted_98 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_99 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_100 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_102 = { class: "flex align-items-center gap-2" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Thiết bị theo khoa/phòng ", -1)
const _hoisted_104 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_106 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thống kê: ", -1)
const _hoisted_108 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng", -1)
const _hoisted_110 = {
  key: 0,
  class: "p-error"
}
const _hoisted_111 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", null, "Thống kê", -1)
const _hoisted_113 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", null, "Xuất tập tin", -1)
const _hoisted_115 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", null, "Tải tập tin", -1)
const _hoisted_117 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_118 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_119 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_121 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TabView, null, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiTiepNhan.length,
                    severity: "contrast"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateAll,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateAll) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadThietBiTiepNhan()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      expandedRowGroups: $setup.expandedRowGroups,
                      "onUpdate:expandedRowGroups": _cache[4] || (_cache[4] = ($event: any) => (($setup.expandedRowGroups) = $event)),
                      value: $setup.listThietBiTiepNhan,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand",
                      expandableRowGroups: "",
                      rowGroupMode: "subheader",
                      groupRowsBy: "loaiThietBi",
                      sortMode: "single",
                      sortField: "loaiThietBi",
                      sortOrder: 1
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_12, [
                            _hoisted_13,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      groupheader: _withCtx((slotProps) => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(slotProps.data.loaiThietBi), 1)
                      ]),
                      groupfooter: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_15, " Tổng số: " + _toDisplayString($setup.calculateGroupTotal(slotProps.data.idLoaiThietBi)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "STT",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Chuyển" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              severity: "success",
                              label: "Chuyển",
                              icon: "pi pi-sync",
                              onClick: ($event: any) => ($setup.chuyenThietBi(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Thanh lý" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              severity: "warning",
                              label: "Chờ thanh lý",
                              icon: "pi pi-ban",
                              onClick: ($event: any) => ($setup.choThanhLyThietBi(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "expandedRowGroups", "value", "filters"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.chuyen,
                    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (($setup.chuyen) = $event)),
                    style: { width: '40vw' },
                    breakpoints: { '1500px': '70vw', '1150px': '80vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Chuyển tài sản" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_InputText, {
                                id: "khoaPhongNhan",
                                type: "text",
                                modelValue: $setup.tenThietBi,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.tenThietBi) = $event)),
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createVNode(_component_Dropdown, {
                                id: "permission",
                                modelValue: $setup.thietBiChuyen.idKhoaPhongTiepNhan,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.thietBiChuyen.idKhoaPhongTiepNhan) = $event)),
                                options: $setup.khoaPhong,
                                optionLabel: "tenKhoaPhong",
                                optionValue: "id",
                                placeholder: "Vui lòng chọn khoa phòng nhận ..."
                              }, null, 8, ["modelValue", "options"]),
                              ($setup.thietBiChuyen.idKhoaPhongTiepNhan < 1)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_22, "Vui lòng chọn khoa phòng nhận"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            ($setup.valid)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  label: "Chuyển",
                                  icon: "pi pi-sync",
                                  iconPos: "left",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.thucHienChuyenThietBi())),
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  label: "Chuyển",
                                  icon: "pi pi-sync",
                                  iconPos: "left",
                                  disabled: "disabled",
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"]),
                  _createVNode(_component_Dialog, {
                    visible: $setup.ngung,
                    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (($setup.ngung) = $event)),
                    style: { width: '50vw' },
                    breakpoints: { '1500px': '60vw', '1150px': '70vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Thanh lý thiết bị" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createVNode(_component_InputText, {
                                id: "tenThietBiNgung",
                                type: "text",
                                modelValue: $setup.thietBiNgung.tenThietBi,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.thietBiNgung.tenThietBi) = $event)),
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode(_component_InputText, {
                                id: "lyDoNgung",
                                type: "text",
                                modelValue: $setup.thietBiNgungHoatDong.lyDoNgung,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.thietBiNgungHoatDong.lyDoNgung) = $event))
                              }, null, 8, ["modelValue"]),
                              ($setup.thietBiNgungHoatDong.lyDoNgung < 1)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_29, "Vui lòng nhập lý do ngưng"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            ($setup.validNgung)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  label: "Thanh lý",
                                  severity: "danger",
                                  icon: "pi pi-trash",
                                  iconPos: "left",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.deactiveThietBi())),
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  label: "Thanh lý",
                                  severity: "danger",
                                  icon: "pi pi-trash",
                                  iconPos: "left",
                                  disabled: "disabled",
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"]),
                  _createVNode(_component_Dialog, {
                    visible: $setup.choThanhLy,
                    "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (($setup.choThanhLy) = $event)),
                    style: { width: '50vw' },
                    breakpoints: { '1500px': '60vw', '1150px': '70vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Chuyển chờ thanh lý thiết bị" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _hoisted_33,
                              _createVNode(_component_InputText, {
                                id: "tenThietBiNgung1",
                                type: "text",
                                modelValue: $setup.thietBiCho.tenThietBi,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.thietBiCho.tenThietBi) = $event)),
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _hoisted_35,
                              _createVNode(_component_InputText, {
                                id: "lyDoNgung1",
                                type: "text",
                                modelValue: $setup.thietBiChoThanhLy.lyDoNgung,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.thietBiChoThanhLy.lyDoNgung) = $event))
                              }, null, 8, ["modelValue"]),
                              ($setup.thietBiChoThanhLy.lyDoNgung < 1)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_36, "Vui lòng nhập lý do ngưng"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            ($setup.validCho)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  label: "Chuyển chờ thanh lý",
                                  severity: "warning",
                                  icon: "pi pi-ban",
                                  iconPos: "left",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.waitingForLiquidationThietBi())),
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  label: "Chuyển chờ thanh lý",
                                  severity: "warning",
                                  icon: "pi pi-ban",
                                  iconPos: "left",
                                  disabled: "disabled",
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiHoatDong.length,
                    severity: "success"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.exportFile($setup.listThietBiHoatDong, 1))),
                      disabled: $setup.listThietBiHoatDong.length < 1
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      severity: "warning",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.downLoadFileExport($setup.fileName))),
                      disabled: !$setup.downloadFile
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      expandedRowGroups: $setup.expandedRowGroups,
                      "onUpdate:expandedRowGroups": _cache[22] || (_cache[22] = ($event: any) => (($setup.expandedRowGroups) = $event)),
                      value: $setup.listThietBiHoatDong,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[23] || (_cache[23] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand",
                      expandableRowGroups: "",
                      rowGroupMode: "subheader",
                      groupRowsBy: "loaiThietBi",
                      sortMode: "single",
                      sortField: "loaiThietBi",
                      sortOrder: 1
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_48, [
                            _hoisted_49,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      groupheader: _withCtx((slotProps) => [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(slotProps.data.loaiThietBi), 1)
                      ]),
                      groupfooter: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_51, " Tổng số: " + _toDisplayString($setup.calculateGroupTotal(slotProps.data.idLoaiThietBi)), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Chuyển" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              severity: "warning",
                              label: "Chuyển",
                              icon: "pi pi-sync",
                              onClick: ($event: any) => ($setup.chuyenThietBi(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "expandedRowGroups", "value", "filters"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.chuyen,
                    "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => (($setup.chuyen) = $event)),
                    style: { width: '40vw' },
                    breakpoints: { '1500px': '70vw', '1150px': '80vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Chuyển tài sản" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createVNode(_component_InputText, {
                                id: "khoaPhongNhanHD",
                                type: "text",
                                modelValue: $setup.tenThietBi,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.tenThietBi) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createVNode(_component_Dropdown, {
                                id: "permissionHD",
                                modelValue: $setup.thietBiChuyen.idKhoaPhongTiepNhan,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.thietBiChuyen.idKhoaPhongTiepNhan) = $event)),
                                options: $setup.khoaPhong,
                                optionLabel: "tenKhoaPhong",
                                optionValue: "id",
                                placeholder: "Vui lòng chọn khoa phòng nhận ..."
                              }, null, 8, ["modelValue", "options"]),
                              ($setup.thietBiChuyen.idKhoaPhongTiepNhan < 1)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_58, "Vui lòng chọn khoa phòng nhận"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            ($setup.valid)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  label: "Chuyển",
                                  icon: "pi pi-sync",
                                  iconPos: "left",
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.thucHienChuyenThietBi())),
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                              : (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  label: "Chuyển",
                                  icon: "pi pi-sync",
                                  iconPos: "left",
                                  disabled: "disabled",
                                  style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                                }))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiHetHan.length,
                    severity: "danger"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _hoisted_65,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateHetHan,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.dateHetHan) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[29] || (_cache[29] = ($event: any) => ($setup.getListThietBiHetHan()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.exportFile($setup.listThietBiHetHan, 2))),
                      disabled: $setup.listThietBiHetHan.length < 1
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      severity: "warning",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameHetHan))),
                      disabled: !$setup.downloadFileHetHan
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      value: $setup.listThietBiHetHan,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[34] || (_cache[34] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_72, [
                            _hoisted_73,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "value", "filters"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiChoThanhLy.length,
                    severity: "warning"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateChoThanhLy,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.dateChoThanhLy) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[36] || (_cache[36] = ($event: any) => ($setup.getListThietBiChoThanhLy()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.exportFile($setup.listThietBiChoThanhLy, 6))),
                      disabled: $setup.listThietBiChoThanhLy.length < 1
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      severity: "warning",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameChoThanhLy))),
                      disabled: !$setup.downloadFileChoThanhLy
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      value: $setup.listThietBiChoThanhLy,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[41] || (_cache[41] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_85, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[39] || (_cache[39] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_86, [
                            _hoisted_87,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Thanh lý" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              severity: "danger",
                              label: "Thanh lý",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.xoaThietBi(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "value", "filters"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiNgungHoatDong.length,
                    severity: "secondary"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_90, [
                  _hoisted_91,
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateNgung,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.dateNgung) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[43] || (_cache[43] = ($event: any) => ($setup.getListThietBiNgungHoatDong()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _hoisted_95,
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[44] || (_cache[44] = ($event: any) => ($setup.exportFile($setup.listThietBiNgungHoatDong, 3))),
                      disabled: $setup.listThietBiNgungHoatDong.length < 1
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      severity: "warning",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameNgung))),
                      disabled: !$setup.downloadFileNgung
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      value: $setup.listThietBiNgungHoatDong,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[48] || (_cache[48] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_99, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[46] || (_cache[46] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_100, [
                            _hoisted_101,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "nguoiNgungHoatDong",
                          header: "Người thực hiện thanh lý",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "lyDoNgung",
                          header: "Lý do thanh lý",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianNgung",
                          header: "Thời gian thanh lý",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianNgung)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "value", "filters"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_102, [
                  _hoisted_103,
                  _createVNode(_component_Badge, {
                    value: $setup.listThietBiTheoKhoa.length,
                    severity: "info"
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_104, [
                  _hoisted_105,
                  _createElementVNode("div", _hoisted_106, [
                    _hoisted_107,
                    _createVNode(_component_Calendar, {
                      id: "date",
                      modelValue: $setup.dateKhoaPhong,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (($setup.dateKhoaPhong) = $event)),
                      selectionMode: "range",
                      dateFormat: "dd/mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createVNode(_component_Dropdown, {
                      id: "khoaPhong",
                      modelValue: $setup.idKhoa,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.idKhoa) = $event)),
                      options: $setup.khoaPhong,
                      optionLabel: "tenKhoaPhong",
                      optionValue: "id",
                      placeholder: "Vui lòng chọn khoa phòng nhận ..."
                    }, null, 8, ["modelValue", "options"]),
                    ($setup.idKhoa < 1)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_110, "Vui lòng chọn khoa phòng"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _hoisted_112,
                    _createVNode(_component_Button, {
                      label: "Thực hiện",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[51] || (_cache[51] = ($event: any) => ($setup.getListThietBiTheoKhoa()))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _hoisted_114,
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[52] || (_cache[52] = ($event: any) => ($setup.exportFile($setup.listThietBiTheoKhoa, 5))),
                      disabled: $setup.listThietBiTheoKhoa.length < 1
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _hoisted_116,
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      severity: "warning",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameKhoaPhong))),
                      disabled: !$setup.downloadFileKhoaPhong
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createVNode(_component_DataTable, {
                      loading: _ctx.isLoading,
                      value: $setup.listThietBiTheoKhoa,
                      paginator: true,
                      stripedRows: "",
                      rows: 10,
                      rowsPerPageOptions: [10, 25, 50],
                      rowHover: true,
                      filters: $setup.filters,
                      "onUpdate:filters": _cache[56] || (_cache[56] = ($event: any) => (($setup.filters) = $event)),
                      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                      globalFilterFields: ['tenThietBi', 'giaTriTiepNhan'],
                      currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
                      columnResizeMode: "fit | expand"
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_118, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-filter-slash",
                            label: "Xoá",
                            class: "p-button-outlined",
                            onClick: _cache[54] || (_cache[54] = ($event: any) => ($setup.clearFilter())),
                            style: {"width":"6em"}
                          }),
                          _createElementVNode("span", _hoisted_119, [
                            _hoisted_120,
                            _createVNode(_component_InputText, {
                              modelValue: $setup.filters['global'].value,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (($setup.filters['global'].value) = $event)),
                              placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Stt",
                          headerStyle: "width:3rem"
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tenThietBi",
                          header: "Tên thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "maThietBi",
                          header: "Mã thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianTiepNhan",
                          header: "Năm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTimeYear(data.thoiGianTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianCapNhat",
                          header: "Thời gian cập nhật",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriTiepNhan",
                          header: "Nguyên giá",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "giaTriHienTai",
                          header: "Giá trị thời điểm tiếp nhận",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "tyLeSuDungConLai",
                          header: "Tỷ lệ sử dụng còn lại",
                          sortable: ""
                        }, {
                          body: _withCtx((slotProps) => [
                            _createTextVNode(_toDisplayString(slotProps.data.tyLeSuDungConLai) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongTiepNhan",
                          header: "Khoa phòng tiếp nhận",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongHienTai",
                          header: "Khoa phòng hiện tại",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "loaiThietBi",
                          header: "Loại thiết bị",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "khoaPhongChuyenGiao",
                          header: "Khoa phòng chuyển giao",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "nguoiNgungHoatDong",
                          header: "Người thực hiện ngưng",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "lyDoNgung",
                          header: "Lý do ngưng",
                          sortable: ""
                        }),
                        _createVNode(_component_Column, {
                          field: "thoiGianNgung",
                          header: "Thời gian ngưng",
                          sortable: ""
                        }, {
                          body: _withCtx(({data}) => [
                            _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianNgung)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Lịch sử bàn giao" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode(_component_Button, {
                              type: "button",
                              label: "Xem",
                              icon: "pi pi-history",
                              onClick: ($event: any) => ($setup.loadChiTiet(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["loading", "value", "filters"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_121, [
      _createVNode(_component_Dialog, {
        visible: $setup.chiTietThietBi,
        "onUpdate:visible": _cache[58] || (_cache[58] = ($event: any) => (($setup.chiTietThietBi) = $event)),
        style: { width: '70vw' },
        breakpoints: { '1500px': '90vw', '1150px': '100vw' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            loading: _ctx.isLoading,
            value: $setup.lichSu,
            paginator: true,
            stripedRows: "",
            rows: 10,
            rowsPerPageOptions: [10, 25, 50],
            rowHover: true,
            filters: $setup.filters,
            "onUpdate:filters": _cache[57] || (_cache[57] = ($event: any) => (($setup.filters) = $event)),
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['tenThietBi'],
            currentPageReportTemplate: "Có tổng số {totalRecords} lần chuyển giao",
            columnResizeMode: "fit | expand"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "tenThietBi",
                header: "Tên thiết bị",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "khoaPhongGiao",
                header: "Khoa phòng chuyển",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "thoiGianGiao",
                header: "Thời gian chuyển",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianGiao)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "khoaPhongNhan",
                header: "Khoa phòng nhận",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "thoiGianXacNhan",
                header: "Thời gian nhận",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianXacNhan)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "nguoiChuyen",
                header: "Người chuyển",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "nguoiNhan",
                header: "Người nhận",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "giaTriTiepNhan",
                header: "Giá trị ban đầu",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "giaTriHienTai",
                header: "Giá trị thời điểm tiếp nhận",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriHienTai)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "value", "filters"])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}